module.exports = __webpack_public_path__ + "media/St 4-Screen 4.355f7f61.wav";